import type { Order } from '../../types/Order';

interface Count {
    orders: number;
    revenue: number;
}

/** Answer of GET /stats (API_CONTRACT_1_1 section 9). Days and hours are cut in the venue's time zone. */
export interface Stats {
    range: { from: string; to: string; days: number; timezone: string };
    currency: { code: string; symbol: string; symbolPosition: 'before' | 'after' };
    totals: {
        /** Not cancelled. */
        orders: number;
        completed: number;
        cancelled: number;
        /** Paid and not cancelled. */
        paidOrders: number;
        revenue: number;
        averageOrderValue: number | null;
        itemsSold: number;
    };
    daily: Array<Count & { date: string }>;
    byHour: Array<Count & { hour: number }>;
    /** 1 = Monday ... 7 = Sunday. */
    byWeekday: Array<Count & { weekday: number }>;
    /** [weekday - 1][hour] = orders. */
    heatmap: number[][];
    topItems: Array<{ menuItemId: string; name: string; quantity: number; revenue: number }>;
    orderTypes: { table: Count; togo: Count };
    payments: { cash: Count; card: Count; unpaid: { orders: number; value: number } };
    timing: {
        sampleSize: number;
        excluded: number;
        /** Seconds; null without a sample. */
        averageToAccept: number | null;
        averageToPrepare: number | null;
        averageToComplete: number | null;
        averageInState: { pending: number | null; accepted: number | null; preparing: number | null; ready: number | null };
    };
}

/** Open orders, oldest first. */
export const liveOrders = (orders: Order[], max = 5): Order[] =>
    orders
        .filter((o) => o.status !== 'completed' && o.status !== 'cancelled')
        .sort((a, b) => a.createdAt.localeCompare(b.createdAt))
        .slice(0, max);
